import { useMutation } from '@tanstack/react-query';
import useSlingApi from '@sdk/api/useSlingApi';

import { useConversationQueryCache } from '@web/conversations/hooks/useConversationQueryCache';

export const useLeaveConversation = () => {
  const { conversation } = useSlingApi();
  const { removeConversation } = useConversationQueryCache();

  const mutation = useMutation({
    mutationFn: (payload: IDObject) => conversation.leave(payload.id),
    onSuccess: (conversation, payload) => {
      removeConversation(payload.id);
    },
  });

  return mutation;
};
